import Phaser from 'phaser';

export default class Enemy extends Phaser.Physics.Arcade.Sprite {
  constructor(scene, x, y, texture, config) {
    super(scene, x, y, texture);

    scene.add.existing(this);
    scene.physics.add.existing(this);

    this.config = config;
    this.stats = {
      hp: config.stats.hp,
      maxHp: config.stats.hp,
      attack: config.stats.attack,
      defense: config.stats.defense,
      speed: config.stats.speed
    };

    this.level = config.level || 1;
    this.type = config.type;
    this.isBoss = config.isBoss || false;

    // AI state
    this.state = 'idle';
    this.aggroRange = config.isBoss ? 300 : 150;
    this.attackRange = 40;

    // Physics
    this.setCollideWorldBounds(true);
    this.body.setSize(24, 24);

    // Create health bar
    this.createHealthBar();
  }

  createHealthBar() {
    const barWidth = this.isBoss ? 60 : 30;
    
    this.healthBarBg = this.scene.add.rectangle(this.x, this.y - 25, barWidth + 2, 6, 0x333333);
    this.healthBar = this.scene.add.rectangle(this.x, this.y - 25, barWidth, 4, 0xFF0000);
    this.healthBarBg.setDepth(5);
    this.healthBar.setDepth(6);
  }

  takeDamage(amount) {
    this.stats.hp -= amount;
    
    // Update health bar
    const healthPercent = Math.max(0, this.stats.hp / this.stats.maxHp);
    const barWidth = this.isBoss ? 60 : 30;
    this.healthBar.width = barWidth * healthPercent;

    // Flash white
    this.setTint(0xFFFFFF);
    this.scene.time.delayedCall(100, () => {
      this.clearTint();
      if (this.isBoss) {
        this.setTint(0x9C27B0);
      }
    });
  }

  update(player) {
    if (!this.active) return;

    // Update health bar position
    this.healthBarBg.setPosition(this.x, this.y - 25);
    this.healthBar.setPosition(this.x - (this.isBoss ? 30 : 15) + this.healthBar.width / 2, this.y - 25);

    // Simple AI
    const distance = Phaser.Math.Distance.Between(this.x, this.y, player.x, player.y);

    if (distance < this.aggroRange) {
      this.state = 'chase';
      
      // Move towards player
      const angle = Phaser.Math.Angle.Between(this.x, this.y, player.x, player.y);
      const speed = this.stats.speed;
      
      if (distance > this.attackRange) {
        this.setVelocity(
          Math.cos(angle) * speed,
          Math.sin(angle) * speed
        );
      } else {
        this.setVelocity(0, 0);
      }
    } else {
      this.state = 'idle';
      // Random wandering
      if (Math.random() < 0.01) {
        const angle = Phaser.Math.FloatBetween(0, Math.PI * 2);
        this.setVelocity(
          Math.cos(angle) * this.stats.speed * 0.3,
          Math.sin(angle) * this.stats.speed * 0.3
        );
      }
    }
  }

  destroy() {
    if (this.healthBar) this.healthBar.destroy();
    if (this.healthBarBg) this.healthBarBg.destroy();
    super.destroy();
  }
}
